import React, { useState } from "react";
import { ViewProfile } from "../../components/settings/profile/View";
import { CreateEditProfile } from "../../components/settings/profile/Edit";

const ProfilePage = () => {
   const [showProfileModal, setShowProfileModal] = useState(false); // Profile Modal State
  return (
    <div>
      {/* <ViewProfile onClose={() => setShowProfileModal(false)}  /> */}
        <CreateEditProfile show={false} />
    </div>
  );
};

export default ProfilePage;
